import React, { useEffect, useState } from "react";
import ConfirmationDlg from "../ConfirmationDlg";
import NormalSelect from "../form/HorizontalNormalSelect";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import { printLocation } from "../../utils/helper";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import { location } from "../../api";

const printSelectedLocation = (locationIds, locations) => {
  const label = [];
  locationIds.forEach((id, index) => {
    const location = locations[index].find((l) => l.id == id);
    if (location) {
      label.push(printLocation(location.location_name));
    }
  });

  return label.join(" - ");
};
export const LocationFilter = ({
  onChange,
  maxLevel = 3,
  enableAll = true,
}) => {
  const { getLocationName } = useAuth();
  const [locations, setLocations] = useState([]);
  const [sublocations, setSublocations] = useState([]);
  const [locationValue, setLocationValue] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [open, setOpen] = useState();
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getLocations();
  }, []);

  async function getLocations() {
    try {
      const res = await location.list("");
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setLocations(data);
        setSublocations([data]);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];

    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
    }
  }, [locationValue]);

  const handleLocationChange = (e, index) => {
    const location_values = [...locationValue];
    location_values.splice(index);
    location_values.push(e.target.value);
    setLocationValue(location_values);
  };

  const handleSelect = () => {
    //remove empty string from locationValue
    const locationValues = locationValue.filter((l) => l);
    if (locationValues.length > 0 && enableAll) {
      const location_id = locationValues[locationValues.length - 1];
      setSelectedLocationId(location_id);
      onChange(location_id);
      setOpen(false);
    } else {
      if (locationValues.length > 1) {
        const location_id = locationValues[locationValues.length - 1];
        setSelectedLocationId(location_id);
        onChange(location_id);
        setOpen(false);
      } else {
        setSelectedLocationId(null);
        onChange(null);
        setOpen(false);
      }
    }
    // const location_id = locationValue[sublocations.length - 1];
    // setSelectedLocationId(location_id);
    // onChange(location_id);
    // setOpen(false);
  };
  return (
    <>
      <button
        onClick={() => {
          setOpen(true);
        }}
        className="btn btn-outline-theme w-100"
      >
        {!selectedLocationId && "- Filter Location - (All)"}
        {selectedLocationId &&
          printSelectedLocation(locationValue, sublocations)}
      </button>
      <ConfirmationDlg
        title={"Select Location"}
        open={open}
        onClose={handleClose}
        onSubmit={handleSelect}
        btnSubmitText={"Submit"}
        btnCancelText={"Cancel"}
      >
        {sublocations.map((sublocation, index) => {
          if (index < maxLevel)
            return (
              <NormalSelect
                key={index}
                required={true}
                value={locationValue[index]}
                label={getLocationName(index)}
                onchange={(e) => handleLocationChange(e, index)}
                list={sublocation}
                name={`id`}
                textKey="location_name"
                defaultValueText={`- Select ${
                  enableAll ? "All" : ""
                } ${getLocationName(index)} -`}
                renderFn={printLocation}
              />
            );
        })}
      </ConfirmationDlg>
    </>
  );
};
